/**
 * FeaturedCarouselCtrl controller
 */

FeaturedCarouselCtrl.mixes = [
  'onOffCtrlMixin'
]

const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

/**
 * FeaturedCarouselCtrl controller
 *
 * @class FeaturedCarouselCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:FeaturedCarouselCtrl
 */
/* @ngInject */
export default function FeaturedCarouselCtrl ($scope, $uibModal, $http, FeaturedCarousel, Featured, pckg, authSvc, alertLiteSvc, alertSvc, featuredSubscriptions) {
  var vm = this
  vm.mixes = [['tabsCtrlMixin', '']]

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * From witch platform drag item
   *
   * @memberof mwApp/packages.controller:CustomizeClientAppSetCtrl
   * @type String
   */
  vm.dragFrom = ''

  /**
   * items for carousel
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @type []
   */
  vm.items = []

  /**
   * Map Types
   *
   * @memberof mwApp/reports.controller:FeaturedCarouselCtrl
   * @type {Object}
   */
  vm.contentTypes = {
    VOD: 'Movies',
    TV_CHANNEL: 'TV Channels',
    TV_SHOW: 'TV Shows'
  }

  /**
   * Available platforms
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @type []
   */
  vm.availablePlatforms = []

  /**
   * Carousels list
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @type {Object}
   */
  vm.carousels = []

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Types list
   *
   * @type {Array}
   */
  vm.types = []
  vm.subscriptions = []

  /**
   * Default values for table state
   *
   * @type {Object}
   */
  const defaultTableState = {
    page: 0,
    count: 75,
    q: '',
    last: false
  }

  vm.searchFeaturedParams = angular.copy(defaultTableState)

  Featured.getContentTypes(vm.pckg.id).then(data => {
    vm.availableTypes = data
  })

  /**
   * Prepare carousel
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @param carousel
   * @param platforms
   */
  vm.prepareCarousel = function (carousel, platforms) {
    const newCarousel = new FeaturedCarousel({ ...carousel, networkId: pckg.id })
    newCarousel.$platforms = newCarousel._enhancePlatforms(['STB'], platforms)
    return newCarousel
  }

  // load banner info
  Featured.loadAll({ networkId: vm.pckg.id, params: vm.searchFeaturedParams })
    .then((res) => {
      vm.currentCarousels = res.content.filter(c => c.subscriptions.length)
      vm.featuredCarousels = []
      vm.loadedFeatured = true
      let length = vm.currentCarousels.length
      let $listOfSubscriptions
      if (featuredSubscriptions.length) {
        $listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featuredSubscriptions)
      } else {
        $listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      }
      while (length > 0) {
        const currentSubscriptionId = vm.currentCarousels[0].subscriptions[0].id
        const carousels = vm.currentCarousels.filter(carousel => carousel.subscriptions.find(s => s.id === currentSubscriptionId)).map(c => new FeaturedCarousel({ ...c, networkId: vm.pckg.id }))
        vm.featuredCarousels.push(new Featured({ carousels, subscriptions: carousels[0].subscriptions, $listOfSubscriptions }))
        vm.currentCarousels = vm.currentCarousels.filter(carousel => !carousel.subscriptions.find(s => s.id === currentSubscriptionId))
        length = vm.currentCarousels.length
      }
      vm.searchFeaturedParams.last = res.last
    })

  vm.carouselSubscriptions = function (featured) {
    return featured.subscriptions.map(s => s.name).join(', ')
  }

  vm.atLeastOneSubscription = function (featured) {
    return featured.subscriptions.length > 0
  }

  vm.getAvailablePlatforms = function (featured) {
    if (!featured.$gettedPlatforms && featured.subscriptions.length) {
      featured.$gettedPlatforms = true
      Featured.getPlatforms(vm.pckg.id, featured.subscriptions.map(s => s.id)).then(res => {
        featured.carousels.forEach(c => {
          const carousel = vm.prepareCarousel(c, res)
          c.$platforms = carousel.$platforms
          c.networkId = carousel.networkId
        })
      })
    }
  }

  vm.deselectSubscription = function (featured, subscription, form) {
    form.$setDirty()
    form.subscription.$setTouched()
    featured.subscriptions = featured.subscriptions.filter(s => s.id !== subscription.id)
    featured.$listOfSubscriptions.shift()
    featured.$listOfSubscriptions = featured.$listOfSubscriptions.concat([subscription])
    if (featured.$listOfSubscriptions.length) {
      featured.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featured.$listOfSubscriptions)
    } else {
      featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    }
    vm.featuredCarousels.forEach(f => {
      f.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
    })
    if (featured.subscriptions.length) {
      Featured.getPlatforms(vm.pckg.id, featured.subscriptions.map(s => s.id)).then(res => {
        featured.carousels.forEach(carousel => {
          carousel.$platforms = carousel._enhancePlatforms(['STB'], res)
        })
      })
    }
    featured.carousels.forEach(c => {
      c.contentItems = c.contentItems.filter(ci => !!ci.inSubscriptions.filter(s => s !== subscription.id).length)
      if (!c.contentItems.length) {
        c.enabled = false
      }
    })
  }

  vm.selectSubscription = function (featured, form) {
    form.$setDirty()
    if (featured.$selectedSubscription.id === 0) {
      featured.$listOfSubscriptions.shift()
      featured.subscriptions = featured.subscriptions.concat(featured.$listOfSubscriptions)
      featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    } else if (featured.$selectedSubscription.id === -1) {
      featured.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featured.subscriptions)
      featured.subscriptions = []
      featured.carousels.forEach(c => {
        c.contentItems = []
        c.enabled = false
      })
    } else {
      featured.subscriptions.push(featured.$selectedSubscription)
      featured.$listOfSubscriptions.shift()
      featured.$listOfSubscriptions = featured.$listOfSubscriptions.filter(s => !featured.subscriptions.find(sub => sub.id === s.id))
      if (featured.$listOfSubscriptions.length) {
        featured.$listOfSubscriptions = [{
          id: 0,
          name: 'All Subscriptions'
        }].concat(featured.$listOfSubscriptions.filter(s => !featured.subscriptions.find(sub => sub.id === s.id)))
      } else {
        featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      }
    }
    vm.featuredCarousels.forEach(f => {
      if (featured.$listOfSubscriptions[0].id === -1 && !f.subscriptions.length) {
        f.$listOfSubscriptions = []
      } else {
        f.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
      }
    })

    if (featured.subscriptions.length) {
      Featured.getPlatforms(vm.pckg.id, featured.subscriptions.map(s => s.id)).then(res => {
        featured.carousels.forEach(carousel => {
          carousel.$platforms = carousel._enhancePlatforms(['STB'], res)
        })
      })
    }
  }

  vm.addFeaturedCarousel = function () {
    let subscriptionsForFeatured
    if (!vm.featuredCarousels.length) {
      subscriptionsForFeatured = [{ id: 0, name: 'All Subscriptions' }].concat(featuredSubscriptions)
    } else {
      if (vm.featuredCarousels[0].$listOfSubscriptions.filter(s => s.id > 0).length) {
        subscriptionsForFeatured = angular.copy(vm.featuredCarousels[0].$listOfSubscriptions)
      } else {
        subscriptionsForFeatured = []
      }
    }
    const carousels = []
    carousels.push(new FeaturedCarousel({ type: 'TV_SHOW' }))
    carousels.push(new FeaturedCarousel({ type: 'VOD' }))
    carousels.push(new FeaturedCarousel({ type: 'TV_CHANNEL' }))
    vm.featuredCarousels.push(new Featured({ $listOfSubscriptions: subscriptionsForFeatured, networkId: vm.pckg.id, carousels }))
  }

  /**
   * Check, if at least one platform is selected
   * @return {Boolean}
   */
  vm.atLeastOnePlatform = function (carousel) {
    if (!carousel) {
      return false
    }

    if (vm.hasAccess(['editFeaturedCarousel', 'editNetwork'])) {
      for (let i = carousel.$platforms.length; i--;) {
        if (carousel.$platforms[i].checked) {
          return true
        }
      }
      return false
    }
    return true
  }

  /**
   * Access check
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @param permissions Array
   * @returns boolean
   */
  vm.hasAccess = function (permissions) {
    return permissions.reduce((accumulator, permission) => {
      return accumulator && authSvc.hasAccess(permission)
    }, true)
  }

  /**
   * Search users params with default values
   *
   * @memberof mwApp/reports.controller:FeaturedCarouselCtrl
   * @type {Object}
   */
  vm.searchItemsParams = {
    q: '',
    page: 0,
    count: 25,
    last: false,
    contentType: '',
    subscriptionIds: []
  }

  /**
   * Filter users, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:FeaturedCarouselCtrl
   * @param  {Object} $select
   * @param  string type
   */
  vm.$timerItems = 0
  vm.openCountItems = 0
  vm.refreshItems = function ($select = {}, carousel, featured) {
    let search = $select.search || ''
    $scope.loading = true

    search = search ? search.toLowerCase() : ''
    vm.searchItemsParams.q = search
    vm.searchItemsParams.page = 0
    vm.items = []

    vm.openCountItems = $select.open ? vm.openCountItems + 1 : 0

    if (vm.openCountItems > 1) {
      vm.searchItemsParams.q = $select.search
    }

    if (vm.openCountItems === 1) {
      $select.search = vm.searchItemsParams.q
    }

    vm.searchItemsParams.contentType = carousel.type

    if ($select.open) {
      window.clearTimeout(vm.$timerItems)
      vm.$timerItems = window.setTimeout(() => {
        carousel._loadItems({ contentType: carousel.type, page: 0, count: 25, q: search, subscriptionIds: featured.subscriptions.map(s => s.id) })
          .then((res) => {
            vm.items = res.content
            vm.searchItemsParams.last = res.last
            vm.searchItemsParams.page = 0
            if (vm.filteredItems(carousel.contentItems).length === 0 && vm.items.length !== 0) {
              return carousel._loadItems({ contentType: carousel.type, page: 1, q: search, subscriptionIds: featured.subscriptions.map(s => s.id) })
                .then((res) => {
                  vm.items = res.content
                  vm.searchItemsParams.last = res.last
                  $scope.loading = false
                })
            }
            $scope.loading = false
          }).catch(err => {
            $scope.loading = false
            alertLiteSvc.alertError(err)
          })
      }, 700)
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   * @param type string
   */
  vm.$timerItemsScroll = 0
  vm.itemsCallbackScroll = (event, carousel, featured) => {
    const { page, last } = vm.searchItemsParams
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerItemsScroll)
      vm.$timerItemsScroll = window.setTimeout(() => {
        carousel._loadItems(
          { ...vm.searchItemsParams, page: page + 1, subscriptionIds: featured.subscriptions.map(s => s.id) }
        )
          .then((res) => {
            vm.items = vm.items.concat(res.content)
            vm.searchItemsParams.page = res.number
            vm.searchItemsParams.last = res.last
          }).catch(err => {
            alertLiteSvc.alertError(err)
          })
      }, 700)
    }
  }

  /**
   * Filtered items
   *
   * @memberof mwApp/packages.controller:CustomizeClientAppCtrl
   * @param contentItems []
   * @return []
   */
  vm.filteredItems = function (contentItems) {
    return vm.items.filter(item => !contentItems.find(i => i.contentId === item.contentId))
  }

  /**
   * Add items to carousel
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @param carousel
   * @param form
   */
  vm.addSelectedItems = function (carousel, form) {
    form.$setDirty()
    if (carousel.$selectedItems) {
      carousel.contentItems = carousel.contentItems.concat(carousel.$selectedItems)
      carousel.$selectedItems = []
    }
  }

  vm.close = function (featured, form, index) {
    const promises = []
    let newCarousel = false
    featured.carousels.forEach(c => {
      if (!c.id) {
        newCarousel = true
      } else {
        promises.push(FeaturedCarousel.load({ networkId: vm.pckg.id, id: c.id }))
      }
    })
    if (newCarousel) {
      vm.featuredCarousels.splice(index, 1)
      featured.$listOfSubscriptions.shift()
      featured.$listOfSubscriptions = featured.$listOfSubscriptions.concat(featured.subscriptions)
      if (featured.$listOfSubscriptions.length) {
        featured.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featured.$listOfSubscriptions)
      } else {
        featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      }
      vm.featuredCarousels.forEach(f => {
        if (featured.$listOfSubscriptions[0].id === -1 && !f.subscriptions.length) {
          f.$listOfSubscriptions = []
        } else {
          f.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
        }
      })
    } else {
      Promise.all(promises).then(res => {
        featured.carousels = res
        featured.subscriptions = featured.carousels[0].subscriptions
        let $listOfSubscriptions = []
        if (vm.featuredCarousels.length > 0) {
          $listOfSubscriptions = vm.featuredCarousels.find((c, i) => i !== index).$listOfSubscriptions.filter(s => s.id > 0)
        }
        $listOfSubscriptions = featuredSubscriptions.concat($listOfSubscriptions)
        const uniq = Array.from(new Set($listOfSubscriptions.map(s => s.id)))
        featured.$listOfSubscriptions = []
        uniq.forEach(id => {
          featured.$listOfSubscriptions.push($listOfSubscriptions.find(s => s.id === id))
        })
        featured.$listOfSubscriptions = featured.$listOfSubscriptions.filter(s => !featured.subscriptions.find(sub => sub.id === s.id))
        if (!featured.$listOfSubscriptions.length) {
          featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
        } else {
          featured.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featured.$listOfSubscriptions)
        }
        vm.featuredCarousels.forEach(f => {
          if (featured.$listOfSubscriptions[0].id === -1 && !f.subscriptions.length) {
            f.$listOfSubscriptions = []
          } else {
            f.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
          }
        })
        featured.$gettedPlatforms = false
        vm.getAvailablePlatforms(featured)
        form.$setPristine()
        featured.is_open = false
      })
    }
  }

  vm.newCarousel = function (featured) {
    return !featured.carousels.find(c => c.id)
  }

  /**
   * Highlight contentItem
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @param item
   */
  vm.highlightItem = function (item) {
    if (vm.hasAccess(['editFeaturedCarousel', 'editNetwork'])) {
      item.$highlighted = !item.$highlighted
    }
  }

  /**
   * Count of highlighted contentItems
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @param carousel FeaturedCarousel
   * @returns number
   */
  vm.highlightedCount = function (carousel) {
    return carousel.contentItems.filter(item => item.$highlighted).length
  }

  /**
   * Delete contentItem from carousel
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @param item
   * @param carousel FeaturedCarousel
   * @param form
   */
  vm.deleteItem = function (item, carousel, form) {
    form.$setDirty()
    carousel.contentItems = carousel.contentItems.filter(i => i.contentId !== item.contentId)
  }

  /**
   * Delete few contentItems from carousel
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @param carousel
   */
  vm.deleteItems = function (carousel) {
    carousel.contentItems = carousel.contentItems.filter(item => !item.$highlighted)
  }

  /**
   * Show delete button for Featured
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   */
  vm.showDeleteButton = function (featured) {
    return authSvc.hasAccess('deleteFeaturedCarousel') || vm.newCarousel(featured)
  }

  /**
   * Delete featured
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   */
  vm.delete = function (featured, index) {
    featured.$listOfSubscriptions.shift()
    featured.$listOfSubscriptions = featured.$listOfSubscriptions.concat(featured.subscriptions)
    if (featured.$listOfSubscriptions.length) {
      featured.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featured.$listOfSubscriptions)
    } else {
      featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    }
    if (vm.newCarousel(featured)) {
      vm.featuredCarousels.splice(index, 1)
      vm.featuredCarousels.forEach(carousel => {
        carousel.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
      })
    } else {
      vm.setDisable()
      Featured.deleteFeatured(vm.pckg.id, featured.subscriptions.map(s => s.id)).then(() => {
        vm.featuredCarousels.splice(index, 1)
        vm.featuredCarousels.forEach(carousel => {
          carousel.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
        })
        if (!vm.featuredCarousels.length) {
          Featured.getAvailableSubscriptions(vm.pckg.id).then((res) => {
            featuredSubscriptions = res
          })
        }
      }).finally(vm.unsetDisable)
    }
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    link.selected = true
    return list.filter(link => link.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event, type) {
    list.dragging = true
    vm.dragFrom = type
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list = list.filter(item => !item.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.dragging = false
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, carousel, form) {
    form.$setDirty()
    if (carousel.type !== vm.dragFrom) {
      return false
    }
    items.forEach(item => { item.selected = false })
    list = list
      .slice(0, index)
      .concat(items)
      .concat(list.slice(index))
    carousel.contentItems = list.filter(item => !item.selected)

    return true
  }

  /**
   * On/Off carousel
   *
   * @memberof mwApp/shows.controller:FeaturedCarouselCtrl
   * @params carousel FeaturedCarousel
   * @params event
   */
  vm.onOffCarousel = function (carousel, event, form) {
    event.preventDefault()
    event.stopPropagation()
    if (!carousel.id || !vm.availableTypes.includes(carousel.type) || carousel.contentItems.length === 0) return
    if (vm.hasAccess(['editFeaturedCarousel', 'editNetwork'])) {
      carousel.enabled = !carousel.enabled
      carousel._onOff().then(() => {
        form.$setDirty()
      }).catch(err => {
        alertLiteSvc.alertError(err.status === 403 ? { data: 'Please assign at least one content item' } : err)
      })
    }
  }

  /**
   * Update Featured Carousel
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @function
   */
  vm.save = function (featured, form, reassignSubscriptions = false) {
    if (!featured.carousels.every(carousel => {
      if (!vm.atLeastOnePlatform(carousel)) {
        alertLiteSvc.alertError(`Select at least one platform for ${vm.contentTypes[carousel.type]}`)
        return false
      }
      return true
    })) {
      return
    }
    // vm.setDisabled()
    (vm.newCarousel(featured) ? $http.post : $http.put)(`api/networks/${vm.pckg.id}/subscriptions/carousels/featured`, {
      carousels: featured.carousels.map(c => {
        const { type, id, enabled, enabledOnModulePage, contentItems } = c
        return {
          type,
          id,
          enabled,
          enabledOnModulePage,
          platformTypes: c.$platforms.filter(p => p.checked).map(p => p.name),
          contentItems: contentItems.map((ci, index) => {
            return { ...ci, order: index, contentType: type }
          })
        }
      }),
      subscriptions: featured.subscriptions.map(s => ({ id: s.id })),
      reassignSubscriptions
    })
      .then((res) => {
        const promisses = []
        if (res.data.payload) {
          res.data.payload.forEach(carousel => {
            promisses.push(FeaturedCarousel.load({ networkId: vm.pckg.id, id: carousel.id }))
          })
        } else {
          featured.carousels.forEach(carousel => {
            promisses.push(FeaturedCarousel.load({ networkId: vm.pckg.id, id: carousel.id }))
          })
        }
        Promise.all(promisses).then(res => {
          featured.carousels = res.map(carousel => vm.prepareCarousel(carousel))
          featured.is_open = false
          form.$setPristine()
        })
        alertLiteSvc.alert(vm.newCarousel(featured) ? 'Featured Carousel created' : 'Featured Carousel updated', 'success', 3000)
      })
      .catch(err => {
        const startPos = err.data.indexOf('[') + 1
        const endPos = err.data.indexOf(']')
        const str = err.data.slice(startPos, endPos)
        const subscrIds = str.split(', ').map(ids => +ids)
        const intersectionSubscriptions = featured.subscriptions.filter(s => subscrIds.includes(s.id))
        if (intersectionSubscriptions.length) {
          var msg = {
            text: 'Are You sure, that You want to override previous featured carousel for the Subscription(s)?',
            header: `Subscription ${intersectionSubscriptions.map(s => s.name).join(', ')} ${intersectionSubscriptions.length === 1 ? 'has' : 'have'} a featured carousel`
          }

          alertSvc.confirm(msg)
            .then(
              () => {
                vm.save(featured, form, true)
              }
            )
        } else {
          alertLiteSvc.alertError(err.data)
        }
      })
  }

  vm.subscriptionEnabled = function (subscription) {
    return subscription.carousels.reduce((enabled, carousel) => { return enabled || carousel.enabled }, false)
  }

  /**
   * Handler for scroll event of Available select list
   *
   * @param event
   */
  vm.$timerContentAvailableScroll = 0
  vm.featuredCallbackScroll = (event) => {
    const {
      last
    } = vm.searchFeaturedParams
    if (!last && event.wheelDelta < 0 && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerContentAvailableScroll)
      vm.$timerContentAvailableScroll = window.setTimeout(() => {
        vm.searchFeaturedParams.page++
        Featured.loadAll({ networkId: vm.pckg.id, params: vm.searchFeaturedParams }).then((res) => {
          vm.searchFeaturedParams.last = res.last
          const subscriptions = res.content.map((sub) => {
            sub.networkId = vm.pckg.id // Hack! set networkId to banner bundle
            return new Featured(sub)
          })
          subscriptions.forEach(sub => {
            sub.carousels.forEach(carousel => {
              vm.prepareCarousel(sub, carousel)
            })
          })
          vm.subscriptions = vm.subscriptions.concat(subscriptions)
        })
      }, 700)
    }
  }
}
